var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$t("ExternalImport"),
      draggable: !_vm.loading && !_vm.dragIsDisabled,
      height: 300
    },
    on: {
      close: _vm.closeExternalImportWindow,
      changePosition: function($event) {
        return _vm.$emit("changeExternalImportWindowPosition", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [
            _c("ExternalImport", { staticClass: "floating-container-svg" })
          ]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c("div", { staticClass: "floating-tool-content" }, [
              _c(
                "div",
                { staticClass: "external-import-objects-div" },
                [
                  _c("HighlightedBox", {
                    attrs: {
                      "bad-object": _vm.badObject,
                      "is-visible": _vm.showInstruction,
                      message: _vm.currentInstruction
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(_vm._s(_vm.$tc("Service", 1)))]),
                  _vm._v(" "),
                  _c("treeselect", {
                    attrs: {
                      options: _vm.serviceOptions,
                      placeholder: null,
                      searchable: false
                    },
                    model: {
                      value: _vm.service,
                      callback: function($$v) {
                        _vm.service = $$v
                      },
                      expression: "service"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v(_vm._s(_vm.$tc("Layer", 1)))]),
                  _vm._v(" "),
                  _c("treeselect", {
                    attrs: {
                      options: _vm.layerOptions,
                      placeholder: null,
                      searchable: false,
                      "default-expand-level": 1,
                      multiple: ""
                    },
                    model: {
                      value: _vm.layers,
                      callback: function($$v) {
                        _vm.layers = $$v
                      },
                      expression: "layers"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("home-window-button", {
              attrs: {
                label: _vm.externalImportSubmitButtonLabel,
                disabled: _vm.externalImportSubmitButtonDisabled
              },
              on: { buttonClick: _vm.importExternalData }
            }),
            _vm._v(" "),
            _c("loading-spinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "accent"
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f18ea85", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f18ea85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/ExternalImport/ExternalImportWindow.vue
// module id = null
// module chunks = 